var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavBarCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 30.9707,
    width: 24,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(-45 17 30.9707)",
    fill: "#1B2F3F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7676,
    y: 14,
    width: 24,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(45 18.7676 14)",
    fill: "#1B2F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBarCrossIcon);
export default __webpack_public_path__ + "static/media/navBarCrossIcon.c076008c2d2c7b0ed6ccaa983809545b.svg";
export { ForwardRef as ReactComponent };